// extracted by mini-css-extract-plugin
export default {"textContentWrapper":"TextContent_textContentWrapper__7nhaj","textContent":"TextContent_textContent__70Vhi","type":"TextContent_type__+s1TA"};